<template>
  <div class="share">
    <Header :white="true" :center="true"/>
    <div class="prompt_wrap">
      <h1>Okay - thank you for joining our campaign.</h1>
      <p>You can follow our campaign to prevent another Grenfell here:</p>
      <div class="button_wrap pt_20">
        <a
          @click="analytics('Facebook-Visit', 'Follow')"
          href="https://www.facebook.com/pages/category/Community-Service/Grenfell-United-286049525266108/"
          target="_blank"
          class="btn facebook"
        >Facebook</a>
        <a
          @click="analytics('Twitter-Visit', 'Follow')"
          href="https://twitter.com/grenfellunited"
          target="_blank"
          class="btn twitter"
        >Twitter</a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: "Share",
  props: ["analytics"],
  components: {
    Header
  }
};
</script>

<!-- #B3D234 -->
<style scoped lang="scss">
.share {
  width: 100%;
  min-height: 100vh;
  background-image: url("../assets/Grenfell1Yr_0004_A.jpg");
  background-size: cover;
  padding-bottom: 20px;
  padding-top: 10px;
  @media only screen and (max-width: 767px) {
    padding: 10px;
  }
  .prompt_wrap {
    width: 100%;
    max-width: 800px;
    background: #fff;
    padding: 60px 40px;
    margin: 0 auto;
    border-radius: 5px;
    margin: 20px auto 0;
    text-align: center;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    @media only screen and (max-width: 767px) {
      padding: 30px 20px 20px;
      margin: 10px auto 0;
    }
    h1 {
      margin: 0 auto 10px;
      font-size: 28px;
      letter-spacing: 0.5px;
      line-height: 1.4;
      @media only screen and (max-width: 767px) {
        font-size: 26px;
      }
    }
    h2 {
      margin: 0 40px 10px;
      font-weight: 500;
      letter-spacing: 0.5px;
      line-height: 1.5;
      @media only screen and (max-width: 767px) {
        font-size: 22px;
      }
    }
    p {
      letter-spacing: 0.5px;
      line-height: 1.5;
      font-weight: 500;
      font-size: 18px;
    }
  }
}
</style>
